import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = ({ activeTab, setActiveTab }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button onClick={() => handleTabChange('home')} className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <img src={process.env.REACT_APP_LOGO_URL} alt="Doctrina Charter School" className="h-14 w-14" />
            <div>
              <h1 className="text-xl font-bold text-navyBlue">DOCTRINA</h1>
              <p className="text-xs text-sageGreen font-medium">Charter School</p>
            </div>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <button onClick={() => handleTabChange('mission')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium">Mission</button>
            <button onClick={() => handleTabChange('mascot')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium">Mascot</button>
            <button onClick={() => handleTabChange('plan')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium">10-Year Plan</button>
            <button onClick={() => handleTabChange('curriculum')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium">Curriculum</button>
            <Button onClick={() => handleTabChange('contact')} className="bg-coralRed hover:bg-coralRed/90 text-white px-6 transition-transform duration-200 hover:scale-105">Get Involved</Button>
          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-navyBlue">
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200 bg-white/95 backdrop-blur-md">
            <div className="flex flex-col space-y-4">
              <button onClick={() => handleTabChange('mission')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium text-left">Mission</button>
              <button onClick={() => handleTabChange('founder')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium text-left">Founder</button>
              <button onClick={() => handleTabChange('campus')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium text-left">Campus</button>
              <button onClick={() => handleTabChange('plan')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium text-left">10-Year Plan</button>
              <button onClick={() => handleTabChange('curriculum')} className="text-navyBlue hover:text-tealAccent transition-colors duration-200 font-medium text-left">Curriculum</button>
              <Button onClick={() => handleTabChange('contact')} className="bg-coralRed hover:bg-coralRed/90 text-white w-full">Get Involved</Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;